module.exports = __webpack_public_path__ + "img/sysdd.962094e9.png";